const apiAddress = 'http://localhost:28083/'

const apiOption = {
	method:'POST',
	mode: 'cors',
}

const apiSubPostCall = async (command, id, formData, progress=null, callback=null, failure=null) => {
	let response = null
	try {
		response = await xhrPromise(apiAddress + command + '/'+id, formData, progress)
		//console.log(response)
		if(callback) callback(response)
	} catch(e) {
		if(failure) failure(e)
	}
	return response
}

const xhrPromise = (url,data,progress=null) => {
	console.log(data,"subpost")
	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest()
		xhr.overrideMimeType("application/json; charset=UTF-8")
		xhr.open('POST', url)
		xhr.upload.addEventListener('progress', (e) => {
			if(progress) {
				progress(e)
			}
		})
		xhr.addEventListener('load', (e) => {
			if (xhr.status === 200) {
				resolve(JSON.parse(xhr.response))
			} else {
				reject(new Error(xhr.statusText))
			}
		})
		xhr.addEventListener('error', (e) => {
			reject(new Error(xhr.statusText))
		})
		xhr.send(data)
	})
}
export default apiSubPostCall
